import {
  EdgeInitdOnboardingConfig,
  KubernetesTaintEffectEnum,
} from '@cast/types-omni';

import { ProvisionNodesCustomConfigurationFormValues } from '../types';

export const buildEdgeInitdConfig = (
  values: ProvisionNodesCustomConfigurationFormValues | undefined
): EdgeInitdOnboardingConfig => {
  const config: EdgeInitdOnboardingConfig = {};

  if (!values) {
    return config;
  }

  if (values.shouldTaint) {
    const taints = (values._customTaints ?? []).filter((t) => t?.key);
    if (taints.length) {
      config.kubernetesTaints = taints.map(({ key, value, effect }) => ({
        key,
        value: value ?? '',
        effect: effect
          ?.replace(/(?<!^)([A-Z])/g, '_$1')
          .toUpperCase() as KubernetesTaintEffectEnum,
      }));
    }
  }

  if (values.shouldUseCustomLabels) {
    const labels = (values._customLabels ?? []).filter((l) => l?.key);
    if (labels.length) {
      config.kubernetesLabels = Object.fromEntries(
        labels.map(({ key, value }) => [key, value ?? ''])
      );
    }
  }

  if (values.replicas) {
    config.gpuConfig = { timeSharing: { replicas: values.replicas } };
  }

  if (values.partitionSize?.trim()) {
    config.gpuConfig = {
      ...config.gpuConfig,
      mig: { partitionSizes: [values.partitionSize.trim()] },
    };
  }

  return config;
};
